import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageInvoices } from "../StartPage.types";

function useStartPageInvoices(year: number, projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.invoices.key(year, projectId),
    queryFn: () => fetchStartPageInvoices(year, projectId)
  });

  return { data, error, isLoading };
}

async function fetchStartPageInvoices(year: number, projectId?: string) {
  const response = await apiWithoutCamelization.get<StartPageInvoices>(
    urls.startPage.invoices.url(year, projectId)
  );
  return response.data;
}

export { useStartPageInvoices };
